const host = typeof window !== 'undefined' ? window.location.hostname : ''
const isDevDomain = host === 'localhost' || host.includes('-dev.oujat.com') || host === 'dev.oujat.com'

export const API_BASE_URL = isDevDomain ? 'https://api-dev.oujat.com' : 'https://api.oujat.com'
const DEV_MEDIA_URL = 'https://oujat-storage.s3.us-east-2.amazonaws.com'
const PROD_MEDIA_URL = 'https://oujat-storage-prod.s3.us-east-2.amazonaws.com'
export const MEDIA_URL = (process.env.REACT_APP_MEDIA_URL || (isDevDomain ? DEV_MEDIA_URL : PROD_MEDIA_URL)).replace(
  /\/$/,
  ''
)

export const ApiEndpoints = {
  CONTACT_WEBSITE: `${API_BASE_URL}/api/v1/misc/website-contact`,
  Content: {
    list: type => `${API_BASE_URL}/api/v1/misc/legalcontent/${type}`
  },
  AUTH: {
    login: `${API_BASE_URL}/api/v1/auth/login/customer`
  },
  COMMON: {
    countries: `${API_BASE_URL}/api/v1/utils/common/countries`,
    states: `${API_BASE_URL}/api/v1/utils/common/states`,
    cities: `${API_BASE_URL}/api/v1/utils/common/cities`
  },
  SERVICE: {
    list: `${API_BASE_URL}/api/v1/misc/services`,
    listbyid: id => `${API_BASE_URL}/api/v1/misc/services/${id}`
  },
  AGENT: {
    list: `${API_BASE_URL}/api/v1/misc/user/agent`
  },
  POPULAR_ROUTES: {
    list: `${API_BASE_URL}/api/v1/misc/popular/international-routes`
  },
  BEST_PERFORMING_AGENTS: {
    list: `${API_BASE_URL}/api/v1/misc/best-performing/agent`
  },
  QMS: {
    list: `${API_BASE_URL}/api/v1/misc/qms`,
    guestDraft: `${API_BASE_URL}/api/v1/qms/guest-draft`
  },
  BLOGS: {
    list: `${API_BASE_URL}/api/v1/misc/blogs`,
    details: blogId => `${API_BASE_URL}/api/v1/misc/blogs/${blogId}`
  },
  CATEGORIES: {
    list: type => `${API_BASE_URL}/api/v1/misc/category/${type}`
  },
  COUNT: {
    list: type => `${API_BASE_URL}/api/v1/misc/services/counts/${type}`
  },
  CATEGORIES_SERVICE: {
    list: category => `${API_BASE_URL}/api/v1/misc/services?category=${category}`
  },
  HELP: {
    list: `${API_BASE_URL}/api/v1/misc/faqs`,
    details: faqId => `${API_BASE_URL}/api/v1/misc/faqs/${faqId}`
  },
  CATEGORY: {
    list: type => `${API_BASE_URL}/api/v1/misc/category/${type}`
  },
  CAREER: {
    list: `${API_BASE_URL}/api/v1/misc/careers`,
    details: careerId => `${API_BASE_URL}/api/v1/misc/careers/${careerId}`,
    addjob: careerId => `${API_BASE_URL}/api/v1/misc/job/application/${careerId}`
  },
  WORLDWIDE_DIRECTORY: {
    list: `${API_BASE_URL}/api/v1/misc/agent/count`,
    stateList: `${API_BASE_URL}/api/v1/misc/agent/count/state`,
    details: `${API_BASE_URL}/api/v1/misc/company/directory`
  },
  STOREFRONT: {
    getByUserId: userId => `${API_BASE_URL}/api/v1/misc/storefront/${userId}`,
    review: userId => `${API_BASE_URL}/api/v1/misc/storefront/reviews/${userId}`
  },
  SERVICES: {
    list: userId => `${API_BASE_URL}/api/v1/misc/agent/services/${userId}`
  },
  /** Public: active plans + default plan-features (marketing site). */
  subscriptionPlans: (userType = 'agent') =>
    `${API_BASE_URL}/api/v1/misc/subscription-plans?userType=${encodeURIComponent(userType)}`
}
